import {takeLatest, put, all, fork, call} from 'redux-saga/effects'

import * as actions from '../actions/actions'
import {putProfile, profile, getOtp} from "../../api/profileApi";
import {profileRecover} from "../../api/passwordApi";
import {push} from "connected-react-router";

export default function* profileSaga() {
  yield all([
    fork(watchFetchProfileEditRequest),
    fork(watchUpdateProfileEditRequest),
    fork(watchEditProfileIdBankFieldChangeRequest),
    fork(watchEditProfileCorporateSenderIdFieldChangeRequest),
    fork(watchEditProfileFullNameFieldChangeRequest),
    fork(watchEditProfileDescriptionFieldChangeRequest),
    fork(watchEditProfileEnabledFieldChangeRequest),
    fork(watchEditProfileProfilenameFieldChangeRequest),
    fork(watchEditProfilePhoneFieldChangeRequest),
    fork(watchEditProfileEmailFieldChangeRequest),
    fork(watchEditProfileResetFieldChangeRequest),
    fork(watchEditPasswordResetFieldChangeRequest),
    fork(watchEditProfileRoleFieldChangeRequest),
    fork(watchEditProfileCleanRequest),
    fork(watchEditUserPictureUploadRequest),
    fork(watchEditProfileLanguageFieldChangeRequest),
    fork(watchEditUserPasswordEditRequest),
    fork(watchResetUserPasswordRequest),
    fork(watchEditProfileNewPasswordFieldChangeRequest),
    fork(watchEditProfileNewPasswordConfirmFieldChangeRequest),
    fork(watchEditProfileNewPasswordFieldCleanRequest),
    fork(watchEditProfileNewPasswordConfirmFieldCleanRequest),
    fork(watchEditProfileOtpChangeRequest),
    fork(watchEditProfileOtpNotificationSendRequest)

  ]);
}

function* watchEditProfileOtpNotificationSendRequest() {
  yield takeLatest(
      actions.EDIT_PROFILE_OTP_NOTIFICATION_SEND_REQUEST,
      editProfileOtpNotificationSendRequest
  )
}

function* editProfileOtpNotificationSendRequest() {
  yield call(getOtp)
}

function* watchEditProfileNewPasswordFieldCleanRequest() {
  yield takeLatest(
      actions.EDIT_PROFILE_NEW_PASSWORD_FIELD_CLEAN_REQUEST,
      editProfileNewPasswordFieldCleanRequest
  )
}

function* editProfileNewPasswordFieldCleanRequest() {
  yield put({type:actions.EDIT_PROFILE_NEW_PASSWORD_FIELD_CLEAN})
}

function* watchEditProfileNewPasswordConfirmFieldCleanRequest() {
  yield takeLatest(
      actions.EDIT_PROFILE_NEW_PASSWORD_CONFIRM_FIELD_CLEAN_REQUEST,
      editProfileNewPasswordConfirmFieldCleanRequest
  )
}

function* editProfileNewPasswordConfirmFieldCleanRequest() {
  yield put({type:actions.EDIT_PROFILE_NEW_PASSWORD_CONFIRM_FIELD_CLEAN})
}

function* watchEditProfileNewPasswordFieldChangeRequest() {
  yield takeLatest(
      actions.EDIT_PROFILE_NEW_PASSWORD_FIELD_CHANGE_REQUEST,
      editProfileNewPasswordFieldChangeRequest
  )
}

function* editProfileNewPasswordFieldChangeRequest(newPassword) {
  yield put({type:actions.EDIT_PROFILE_NEW_PASSWORD_FIELD_CHANGE, value: newPassword.value})
}

function* watchEditProfileNewPasswordConfirmFieldChangeRequest() {
  yield takeLatest(
      actions.EDIT_PROFILE_NEW_PASSWORD_CONFIRM_FIELD_CHANGE_REQUEST,
      editProfileNewPasswordConfirmFieldChangeRequest
  )
}

function* editProfileNewPasswordConfirmFieldChangeRequest(newPasswordConfirm) {
  yield put({type:actions.EDIT_PROFILE_NEW_PASSWORD_CONFIRM_FIELD_CHANGE, value: newPasswordConfirm.value})
}

function* watchEditProfileOtpChangeRequest() {
  yield takeLatest(
      actions.EDIT_PROFILE_OTP_CHANGE_REQUEST,
      editProfileOtpRequest
  )
}

function* editProfileOtpRequest(otp) {
  yield put({type:actions.EDIT_PROFILE_OTP_CHANGE, value: otp.value})
}

function* watchEditUserPasswordEditRequest() {
  yield takeLatest(
      actions.EDIT_USER_PASSWORD_CHANGE_REQUEST,
      EditUserPasswordEditRequest
  )
}

function* EditUserPasswordEditRequest(passwordChangeBoolean) {
  yield put({type:actions.EDIT_USER_PASSWORD_CHANGE,value:passwordChangeBoolean.value})
}


function* watchEditUserPictureUploadRequest() {
  yield takeLatest(
      actions.EDIT_USER_PICTURE_UPLOAD_REQUEST,
      EditUserPictureUploadRequest
  )
}
function* EditUserPictureUploadRequest(imageString) {
  yield put({type:actions.EDIT_USER_PICTURE_UPLOAD,value:imageString.value})
}


function* watchFetchProfileEditRequest() {
  yield takeLatest(
    actions.FETCH_PROFILE_EDIT_REQUEST,
    fetchProfileEditRequest
  )
}

function* fetchProfileEditRequest(profileData){
  yield put({ type: actions.PROGRESS_START_REQUEST })
  yield put({ type: actions.EDIT_PROFILE_CLEAN})
  try {
    let { data } = yield call(profile, profileData.value)
    yield put({ type: actions.FETCH_PROFILE_EDIT_SUCCESS, value: data })
    yield put(push(`/profile`))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_PROFILE_EDIT_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
    }else if(error.request)
    {
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error.response })
    }
  }
}

function* watchUpdateProfileEditRequest() {
  yield takeLatest(
    actions.UPDATE_PROFILE_EDIT_REQUEST,
    updateProfileRequestEdit
  )
}

function* updateProfileRequestEdit(profile) {
  yield put({type: actions.CLEAN_ERROR})
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(putProfile, profile.value)
    yield put({ type: actions.UPDATE_PROFILE_EDIT_SUCCESS, value: data })
    yield put(push(`/home`))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
    // yield put({ type: actions.EDIT_PROFILE_CLEAN_REQUEST })
  } catch (error) {
    yield put({ type: actions.UPDATE_PROFILE_EDIT_FAILURE, error: error.response.data })
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  }
}

function* watchEditProfileFullNameFieldChangeRequest() {
  yield takeLatest(
    actions.EDIT_PROFILE_FULL_NAME_FIELD_CHANGE_REQUEST,
    editProfileFullNameFieldChangeRequest
  )
}

function* editProfileFullNameFieldChangeRequest(fullName) {
  yield put({ type: actions.EDIT_PROFILE_FULL_NAME_FIELD_CHANGE, value: fullName.value })
}

function* watchEditProfileDescriptionFieldChangeRequest() {
  yield takeLatest(
    actions.EDIT_PROFILE_DESCRIPTION_FIELD_CHANGE_REQUEST,
    editProfileDescriptionFieldChangeRequest
  )
}

function* editProfileDescriptionFieldChangeRequest(description) {
  yield put({ type: actions.EDIT_PROFILE_DESCRIPTION_FIELD_CHANGE, value: description.value })
}

function* watchEditProfileEnabledFieldChangeRequest() {
  yield takeLatest(
    actions.EDIT_PROFILE_ENABLED_FIELD_CHANGE_REQUEST,
    editProfileEnabledFieldChangeRequest
  )
}

function* editProfileEnabledFieldChangeRequest(enabled) {
  yield put({ type: actions.EDIT_PROFILE_ENABLED_FIELD_CHANGE, value: enabled.value })
}

function* watchEditProfileProfilenameFieldChangeRequest() {
  yield takeLatest(
    actions.EDIT_PROFILE_PROFILE_NAME_FIELD_CHANGE_REQUEST,
    editProfileProfilenameFieldChangeRequest
  )
}

function* editProfileProfilenameFieldChangeRequest(username) {
  yield put({ type: actions.EDIT_PROFILE_PROFILE_NAME_FIELD_CHANGE, value: username.value })
}

function* watchEditProfilePhoneFieldChangeRequest() {
  yield takeLatest(
    actions.EDIT_PROFILE_PHONE_FIELD_CHANGE_REQUEST,
    editProfilePhoneFieldChangeRequest
  )
}

function* editProfilePhoneFieldChangeRequest(phone) {
  yield put({ type: actions.EDIT_PROFILE_PHONE_FIELD_CHANGE, value: phone.value })
}

function* watchEditProfileEmailFieldChangeRequest() {
  yield takeLatest(
    actions.EDIT_PROFILE_EMAIL_FIELD_CHANGE_REQUEST,
    editProfileEmailFieldChangeRequest
  )
}

function* editProfileEmailFieldChangeRequest(email) {
  yield put({ type: actions.EDIT_PROFILE_EMAIL_FIELD_CHANGE, value: email.value })
}

function* watchEditProfileResetFieldChangeRequest() {
  yield takeLatest(
    actions.EDIT_PROFILE_RESET_FIELD_CHANGE_REQUEST,
    editProfileResetFieldChangeRequest
  )
}

function* editProfileResetFieldChangeRequest(reset) {
  yield put({ type: actions.EDIT_PROFILE_RESET_FIELD_CHANGE, value: reset.value })
}

function* watchEditPasswordResetFieldChangeRequest() {
  yield takeLatest(
    actions.EDIT_PROFILE_PASSWORD_FIELD_CHANGE_REQUEST,
    editProfilePasswordFieldChangeRequest
  )
}

function* editProfilePasswordFieldChangeRequest(password) {
  yield put({ type: actions.EDIT_PROFILE_PASSWORD_FIELD_CHANGE, value: password.value })
}

function* editProfilePasswordConfirmFieldChangeRequest(passwordConfirm) {
  yield put({ type: actions.EDIT_PROFILE_PASSWORD_CONFIRM_FIELD_CHANGE, value: passwordConfirm.value })
}

function* watchEditProfileRoleFieldChangeRequest() {
  yield takeLatest(
    actions.EDIT_PROFILE_ROLE_FIELD_CHANGE_REQUEST,
    editProfileRoleFieldChangeRequest
  )
}

function* editProfileRoleFieldChangeRequest(role) {
  yield put({ type: actions.EDIT_PROFILE_ROLE_FIELD_CHANGE, value: role.value.value })
}

function* watchEditProfileIdBankFieldChangeRequest() {
  yield takeLatest(
    actions.EDIT_PROFILE_ID_BANK_FIELD_CHANGE_REQUEST,
    editProfileIdBankFieldChangeRequest
  )
}

function* editProfileIdBankFieldChangeRequest(idBank) {
  if(idBank.value !== null)
    yield put({type: actions.EDIT_PROFILE_ID_BANK_FIELD_CHANGE, value: idBank.value.bankId})
  else
    yield put({type: actions.EDIT_PROFILE_ID_BANK_FIELD_CHANGE, value: ''})
}

function* watchEditProfileCorporateSenderIdFieldChangeRequest() {
  yield takeLatest(
    actions.EDIT_PROFILE_CORPORATE_SENDER_ID_FIELD_CHANGE_REQUEST,
    editProfileCorporateSenderIdFieldChangeRequest
  )
}

function* editProfileCorporateSenderIdFieldChangeRequest(corporateSenderId) {
  if(corporateSenderId.value !== null)
    yield put({type: actions.EDIT_PROFILE_CORPORATE_SENDER_ID_FIELD_CHANGE, value: corporateSenderId.value.corporateSenderId})
  else
    yield put({type: actions.EDIT_PROFILE_CORPORATE_SENDER_ID_FIELD_CHANGE, value: ''})
}

function* watchEditProfileCleanRequest() {
  yield takeLatest(
    actions.EDIT_PROFILE_CLEAN_REQUEST,
    editProfileCleanRequest
  )
}

function* editProfileCleanRequest() {
  yield put({type: actions.EDIT_PROFILE_CLEAN})
}

function* watchEditProfileLanguageFieldChangeRequest() {
  yield takeLatest(
    actions.EDIT_PROFILE_LANGUAGE_FIELD_CHANGE_REQUEST,
    editProfileLanguageFieldChangeRequest
  )
}

function* editProfileLanguageFieldChangeRequest(language) {
  yield put({ type: actions.EDIT_PROFILE_LANGUAGE_FIELD_CHANGE, value: language.value })
}

function* watchResetUserPasswordRequest() {
  yield takeLatest(
      actions.RESET_USER_PASSWORD_REQUEST,
      resetUserPasswordRequest
  )
}

function* resetUserPasswordRequest(user) {
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    yield call(profileRecover, user.value)
    yield put({ type: actions.AUTHENTICATION_LOGOUT_REQUEST})
    yield put(push(`/${localStorage.getItem('bank')}/login`))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {
    yield put({ type: actions.UPDATE_PROFILE_EDIT_FAILURE, error: error.response.data })
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  }
}